import authorizedInstance from '../../../core/api/authorizedInstance';
import { CompleteEnrollmentPayload, CompleteEnrollmentResponse, EnrollmentFormData, EnrollmentResponse } from '../types/enrollment';

export const ENROLLMENT_BASE_API_ENDPOINT = '/api/v1/students';

export const updateEnrollment = (memberId: string, payload: Partial<EnrollmentFormData>,  signal?: AbortSignal) => {
  return authorizedInstance.put<EnrollmentResponse>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/member-update`,
    payload,
    { signal }
  );
};

export const completeEnrollment = (memberId: string, payload?: CompleteEnrollmentPayload, signal?: AbortSignal) => {
  return authorizedInstance.post<CompleteEnrollmentResponse>(
    `${ENROLLMENT_BASE_API_ENDPOINT}/${memberId}/complete-member-enrollment`,
    payload || {},
    { signal }
  );
};

